import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import HomePageBanner from "../../Components/HomePageBanner/HomePageBanner";
import Login from "../../Components/Login/Login";
import Page from "../../Components/MetaPage/Page";
import { getRemoteValue } from "../../Utils/firebase";
import { sendEvent } from "../../Utils/firebaseLogger";


const HomePage = () => {

  const [isLoadLogged, setIsLoadLogged] = useState(false);

  useEffect(() => {
    if (!isLoadLogged) {
      setIsLoadLogged(true);
      sendEvent(`view_landing_page`, {});
    }
  }, []);

  return (
    <Page
      title={getRemoteValue("payments")}
      // CRL-3241: stretch so login area + visual fill the space between navbar and footer
      sx={{ flex: 1, display: "flex", flexDirection: "column" }}
    >
      <Grid container sx={{ flex: 1, alignItems: "stretch" }}>
        <Grid
          item
          xs={12}
          lg={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#FFFFFF",
            paddingX: "16px",
            paddingTop: "32px",
            paddingBottom: "48px",
            "@media (min-width: 1200px)": {
              paddingY: "48px",
            },
          }}
        >
          <Login />
        </Grid>
        <Grid
          item
          className="hidden lg:flex items-stretch relative"
          xs={12}
          lg={6}
        >
          <HomePageBanner />
        </Grid>
      </Grid>
    </Page>
  );
};

export default HomePage;
